import React, { useState, useEffect } from 'react';
import { fpBackButton, fpCard, fpHeader, fpHeaderTitle, fpStickerSmall } from '../utils/fpUi';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, X, Image, BookOpen, Grid3X3 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useDarkMode } from '../contexts/DarkModeContext';
import { useDiscrete } from '../contexts/DiscreteContext';

// Gallery images data with thumbnails for fast loading
const galleryImages = [
  // New comics
  { id: 39, src: '/commissions-gallery/comic_low_MHA.jpg', thumb: '/commissions-gallery/thumbnails/comic_low_MHA_thumb.jpg', type: 'comic' },
  { id: 40, src: '/commissions-gallery/comic_low_naruto.jpg', thumb: '/commissions-gallery/thumbnails/comic_low_naruto_thumb.jpg', type: 'comic' },
  { id: 41, src: '/commissions-gallery/comic_low_naruto_pag2.jpg', thumb: '/commissions-gallery/thumbnails/comic_low_naruto_pag2_thumb.jpg', type: 'comic' },
  // New illustration
  { id: 42, src: '/commissions-gallery/low_Mugen_and_Jin.jpg', thumb: '/commissions-gallery/thumbnails/low_Mugen_and_Jin_thumb.jpg', type: 'illustration' },
  // Existing
  { id: 1, src: '/commissions-gallery/comic_Bardock_Pag.jpg', thumb: '/commissions-gallery/thumbnails/comic_Bardock_Pag_thumb.jpg', type: 'comic' },
  { id: 2, src: '/commissions-gallery/1_color.jpg', thumb: '/commissions-gallery/thumbnails/1_color_thumb.jpg', type: 'illustration' },
  { id: 3, src: '/commissions-gallery/1_color_low.jpg', thumb: '/commissions-gallery/thumbnails/1_color_low_thumb.jpg', type: 'illustration' },
  { id: 4, src: '/commissions-gallery/Fasha_color.jpg', thumb: '/commissions-gallery/thumbnails/Fasha_color_thumb.jpg', type: 'illustration' },
  { id: 5, src: '/commissions-gallery/LOW_1_B_color.jpg', thumb: '/commissions-gallery/thumbnails/LOW_1_B_color_thumb.jpg', type: 'illustration' },
  { id: 6, src: '/commissions-gallery/LOW_Arias - Osora_color.jpg', thumb: '/commissions-gallery/thumbnails/LOW_Arias - Osora_color_thumb.jpg', type: 'illustration' },
  { id: 7, src: '/commissions-gallery/Mamoru Chiba_color.jpg', thumb: '/commissions-gallery/thumbnails/Mamoru Chiba_color_thumb.jpg', type: 'illustration' },
  { id: 8, src: '/commissions-gallery/Nobisuke Nobi_low.jpg', thumb: '/commissions-gallery/thumbnails/Nobisuke Nobi_low_thumb.jpg', type: 'illustration' },
  { id: 9, src: '/commissions-gallery/gglow_color.jpg', thumb: '/commissions-gallery/thumbnails/gglow_color_thumb.jpg', type: 'illustration' },
  { id: 10, src: '/commissions-gallery/goku and gohan_color.jpg', thumb: '/commissions-gallery/thumbnails/goku and gohan_color_thumb.jpg', type: 'illustration' },
  { id: 11, src: '/commissions-gallery/goku_color.jpg', thumb: '/commissions-gallery/thumbnails/goku_color_thumb.jpg', type: 'illustration' },
  { id: 12, src: '/commissions-gallery/low_1 v2_color.jpg', thumb: '/commissions-gallery/thumbnails/low_1 v2_color_thumb.jpg', type: 'illustration' },
  { id: 13, src: '/commissions-gallery/low_1.jpg', thumb: '/commissions-gallery/thumbnails/low_1_thumb.jpg', type: 'illustration' },
  { id: 14, src: '/commissions-gallery/low_1_Color.jpg', thumb: '/commissions-gallery/thumbnails/low_1_Color_thumb.jpg', type: 'illustration' },
  { id: 15, src: '/commissions-gallery/low_Bardock.jpg', thumb: '/commissions-gallery/thumbnails/low_Bardock_thumb.jpg', type: 'illustration' },
  { id: 16, src: '/commissions-gallery/low_Beryl Gardenant.jpg', thumb: '/commissions-gallery/thumbnails/low_Beryl Gardenant_thumb.jpg', type: 'illustration' },
  { id: 17, src: '/commissions-gallery/low_Comm39_Saiyan.jpg', thumb: '/commissions-gallery/thumbnails/low_Comm39_Saiyan_thumb.jpg', type: 'illustration' },
  { id: 18, src: '/commissions-gallery/low_Dick, Jason and Tim.jpg', thumb: '/commissions-gallery/thumbnails/low_Dick, Jason and Tim_thumb.jpg', type: 'illustration' },
  { id: 19, src: '/commissions-gallery/low_Gaston_color.jpg', thumb: '/commissions-gallery/thumbnails/low_Gaston_color_thumb.jpg', type: 'illustration' },
  { id: 20, src: '/commissions-gallery/low_Hawkeye_color.jpg', thumb: '/commissions-gallery/thumbnails/low_Hawkeye_color_thumb.jpg', type: 'illustration' },
  { id: 21, src: '/commissions-gallery/low_Hisoka v1.jpg', thumb: '/commissions-gallery/thumbnails/low_Hisoka v1_thumb.jpg', type: 'illustration' },
  { id: 22, src: '/commissions-gallery/low_John Smith.jpg', thumb: '/commissions-gallery/thumbnails/low_John Smith_thumb.jpg', type: 'illustration' },
  { id: 23, src: '/commissions-gallery/low_Kevin y Ben.jpg', thumb: '/commissions-gallery/thumbnails/low_Kevin y Ben_thumb.jpg', type: 'illustration' },
  { id: 24, src: '/commissions-gallery/low_Luke.jpg', thumb: '/commissions-gallery/thumbnails/low_Luke_thumb.jpg', type: 'illustration' },
  { id: 25, src: '/commissions-gallery/low_Mark Grayson_color.jpg', thumb: '/commissions-gallery/thumbnails/low_Mark Grayson_color_thumb.jpg', type: 'illustration' },
  { id: 26, src: '/commissions-gallery/low_Mark_color.jpg', thumb: '/commissions-gallery/thumbnails/low_Mark_color_thumb.jpg', type: 'illustration' },
  { id: 27, src: '/commissions-gallery/low_Richard Duke_color.jpg', thumb: '/commissions-gallery/thumbnails/low_Richard Duke_color_thumb.jpg', type: 'illustration' },
  { id: 28, src: '/commissions-gallery/low_Zenigata_color.jpg', thumb: '/commissions-gallery/thumbnails/low_Zenigata_color_thumb.jpg', type: 'illustration' },
  { id: 29, src: '/commissions-gallery/low_baby vegeta.jpg', thumb: '/commissions-gallery/thumbnails/low_baby vegeta_thumb.jpg', type: 'illustration' },
  { id: 30, src: '/commissions-gallery/low_braceface.jpg', thumb: '/commissions-gallery/thumbnails/low_braceface_thumb.jpg', type: 'illustration' },
  { id: 31, src: '/commissions-gallery/low_color.jpg', thumb: '/commissions-gallery/thumbnails/low_color_thumb.jpg', type: 'illustration' },
  { id: 32, src: '/commissions-gallery/low_goku_color.jpg', thumb: '/commissions-gallery/thumbnails/low_goku_color_thumb.jpg', type: 'illustration' },
  { id: 33, src: '/commissions-gallery/low_hiei_color.jpg', thumb: '/commissions-gallery/thumbnails/low_hiei_color_thumb.jpg', type: 'illustration' },
  { id: 34, src: '/commissions-gallery/low_jigen_color.jpg', thumb: '/commissions-gallery/thumbnails/low_jigen_color_thumb.jpg', type: 'illustration' },
  { id: 35, src: '/commissions-gallery/low_murdoc_color.jpg', thumb: '/commissions-gallery/thumbnails/low_murdoc_color_thumb.jpg', type: 'illustration' },
  { id: 36, src: '/commissions-gallery/low_yamcha_Color.jpg', thumb: '/commissions-gallery/thumbnails/low_yamcha_Color_thumb.jpg', type: 'illustration' },
  { id: 37, src: '/commissions-gallery/marca_Black Wagreymon.jpg', thumb: '/commissions-gallery/thumbnails/marca_Black Wagreymon_thumb.jpg', type: 'illustration' },
  { id: 38, src: '/commissions-gallery/marca_Makoto_color.jpg', thumb: '/commissions-gallery/thumbnails/marca_Makoto_color_thumb.jpg', type: 'illustration' },
];

export default function CommissionsGallery() {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { isDarkMode } = useDarkMode();
  const { isDiscreteMode, discreteBlurStyle } = useDiscrete();
  const [filter, setFilter] = useState('all');
  const [selectedImage, setSelectedImage] = useState(null);
  const [loadedImages, setLoadedImages] = useState({});

  const filteredImages = galleryImages.filter(img => {
    if (filter === 'all') return true;
    return img.type === filter;
  });

  const handleImageLoad = (id) => {
    setLoadedImages(prev => ({ ...prev, [id]: true }));
  };

  const openFullscreen = (image) => {
    setSelectedImage(image);
  };

  const closeFullscreen = () => {
    setSelectedImage(null);
  };

  // Close on escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') closeFullscreen();
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div style={{
      ...styles.container,
      ...(isDarkMode ? { backgroundImage: 'none', backgroundColor: '#000000' } : {}),
    }}>
      {/* Header */}
      <div style={{
        ...styles.header,
        ...(isDarkMode ? { backgroundColor: '#000000', borderBottom: '1px solid #333', boxShadow: 'none' } : {}),
      }}>
        <button onClick={() => navigate('/')} style={{
          ...styles.backButton,
          ...(isDarkMode ? { background: '#ffffff' } : {}),
        }}>
          <ArrowLeft size={20} color={isDarkMode ? "#000" : "#fff"} />
        </button>
        <h2 style={styles.headerTitle}>{t('commissionsCompleted')}</h2>
        <div style={styles.spacer} />
      </div>

      {/* Content */}
      <div style={styles.content}>
        {/* Subtitle */}
        <p style={styles.subtitle}>{t('commissionsGallerySubtitle')}</p>

        {/* Filter Buttons */}
        <div style={styles.filterContainer}>
          <button
            onClick={() => setFilter('all')}
            style={{
              ...styles.filterButton,
              ...(filter === 'all' ? styles.filterButtonActive : {}),
            }}
          >
            <Grid3X3 size={16} />
            <span>{t('filterAll')}</span>
          </button>
          <button
            onClick={() => setFilter('comic')}
            style={{
              ...styles.filterButton,
              ...(filter === 'comic' ? styles.filterButtonActive : {}),
            }}
          >
            <BookOpen size={16} />
            <span>Comics</span>
          </button>
          <button
            onClick={() => setFilter('illustration')}
            style={{
              ...styles.filterButton,
              ...(filter === 'illustration' ? styles.filterButtonActive : {}),
            }}
          >
            <Image size={16} />
            <span>{t('filterIllustration')}</span>
          </button>
        </div>

        {/* Gallery Grid */}
        <div style={styles.gallery}>
          {filteredImages.map((image) => (
            <div
              key={image.id}
              style={styles.imageCard}
              onClick={() => openFullscreen(image)}
            >
              <div style={styles.imageWrapper}>
                {!loadedImages[image.id] && (
                  <div style={styles.imagePlaceholder}>
                    <div style={styles.skeletonShimmer}></div>
                  </div>
                )}
                <img
                  src={image.thumb || image.src}
                  alt={`Commission ${image.id}`}
                  style={{
                    ...styles.thumbnail,
                    ...discreteBlurStyle,
                    opacity: loadedImages[image.id] ? 1 : 0,
                    transition: 'opacity 0.3s ease, filter 0.3s ease',
                  }}
                  onLoad={() => handleImageLoad(image.id)}
                  loading="lazy"
                />
                <div style={styles.imageOverlay}>
                  <span style={styles.typeBadge}>
                    {image.type === 'comic' ? '📖' : '🎨'}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Fullscreen Modal */}
      {selectedImage && (
        <div style={styles.fullscreenOverlay} onClick={closeFullscreen}>
          <button style={styles.closeButton} onClick={closeFullscreen}>
            <X size={28} color="#fff" />
          </button>
          <div style={styles.fullscreenImageContainer} onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage.src}
              alt={`Commission ${selectedImage.id}`}
              style={{
                ...styles.fullscreenImage,
                ...discreteBlurStyle,
                transition: 'filter 0.3s ease',
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundImage: 'url(/wallpaper.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    backgroundColor: 'rgba(26, 26, 46, 0.95)',
    color: 'white',
    flexShrink: 0,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    ...fpHeader,
  },
  backButton: {
    background: 'linear-gradient(135deg, #FF1493 0%, #FF69B4 100%)',
    border: 'none',
    cursor: 'pointer',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    boxShadow: '0 2px 8px rgba(255, 20, 147, 0.4)',
    ...fpBackButton,
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: 'bold',
    margin: 0,
    ...fpHeaderTitle,
  },
  spacer: {
    width: '44px',
  },
  content: {
    flex: 1,
    padding: '20px 16px',
    overflowY: 'auto',
  },
  subtitle: {
    fontSize: '14px',
    color: '#fff',
    textAlign: 'center',
    marginBottom: '20px',
    textShadow: '0 1px 3px rgba(0, 0, 0, 0.5)',
    lineHeight: '1.5',
    fontWeight: 'bold',
  },
  filterContainer: {
    display: 'flex',
    gap: '8px',
    marginBottom: '20px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  filterButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '10px 16px',
    backgroundColor: '#000',
    border: '2px solid #333',
    borderRadius: '25px',
    color: '#fff',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s',
    ...fpStickerSmall,
  },
  filterButtonActive: {
    backgroundColor: '#FFD700',
    borderColor: '#FFD700',
    color: '#000',
    boxShadow: '0 4px 12px rgba(255, 215, 0, 0.4)',
  },
  gallery: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))',
    gap: '12px',
  },
  imageCard: {
    cursor: 'pointer',
    borderRadius: '12px',
    overflow: 'hidden',
    backgroundColor: '#fff',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
    transition: 'transform 0.2s, box-shadow 0.2s',
    ...fpCard,
  },
  imageWrapper: {
    position: 'relative',
    aspectRatio: '1',
    overflow: 'hidden',
  },
  thumbnail: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'opacity 0.3s, transform 0.3s',
  },
  imagePlaceholder: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#f0f0f0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingSpinner: {
    width: '30px',
    height: '30px',
    border: '3px solid #e0e0e0',
    borderTopColor: '#FF1493',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  skeletonShimmer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'linear-gradient(90deg, #2a2a3e 0%, #3a3a4e 50%, #2a2a3e 100%)',
    backgroundSize: '200% 100%',
    animation: 'shimmer 1.5s infinite',
  },
  imageOverlay: {
    position: 'absolute',
    bottom: '8px',
    right: '8px',
  },
  typeBadge: {
    fontSize: '16px',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    borderRadius: '50%',
    width: '28px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  // Fullscreen styles
  fullscreenOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.95)',
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  closeButton: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    background: 'rgba(255, 255, 255, 0.2)',
    border: 'none',
    borderRadius: '50%',
    width: '48px',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    zIndex: 10000,
  },
  fullscreenImageContainer: {
    maxWidth: '100%',
    maxHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fullscreenImage: {
    maxWidth: '100%',
    maxHeight: '90vh',
    objectFit: 'contain',
    borderRadius: '8px',
  },
};
